import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, ButtonIcon } from 'rmwc/Button';
import { Link } from 'react-router-dom'
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { ListDivider } from 'rmwc/List';
import * as api from '../../api/api'
import * as actions from '../../actions'

class AdminMCListOfResourcesInt extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
    		data:{
	      		resourceId: '',
	      		resourceName: '',
	      		resourceLink: '',
	      		roadmapName: '',
	      		competencyName: '',
	      		levelName: '',
	      		trackName: '',
	      		createdAt: ''
	    	},
	    	resourceData: []
		};
	}

	componentDidMount() {
		let resourceData = Object.assign({}, this.state.resourceData)
		resourceData = this.props.resources
		this.setState({resourceData: resourceData})
	}

	render() {
		let tableComponent = (
			<tbody>
	            {this.state.resourceData.map(function(resource){
	            	if (resource.resource_link.length > 0) {
		            	return(
		            		<tr>
		            			<td>{resource.count}</td>
		            			<td>{resource.name}</td>
		            			<td>{resource.level_name}</td>
		            			<td>{resource.track_name}</td>
		            			<td>{resource.competency_name}</td>
		            			<td>{resource.roadmap_name}</td>
		            			<td>{resource.created_at}</td>
		            			<td><a href={resource.resource_link} target="_blank" style={{cursor: 'pointer'}}> View </a></td>
		            		</tr>
		            	)
		            }
		            else {
		            	return(
		            		<tr>
		            			<td>{resource.count}</td>
		            			<td>{resource.name}</td>
		            			<td>{resource.level_name}</td>
		            			<td>{resource.track_name}</td>
		            			<td>{resource.competency_name}</td>
		            			<td>{resource.roadmap_name}</td>
		            			<td>{resource.created_at}</td>
		            			<td>NA</td>
		            		</tr>
		            	)
		            }
	            })}
	        </tbody>
	    )

	    return(
	    	<Grid>
        		<GridCell span="12">
        			<table>
        				<th>S.No</th>
			            <th>Resource Name</th>
			            <th>Level</th>
			            <th>Track</th>
			            <th>Competency</th>
			            <th>Roadmap</th>
			            <th>Created At</th>
			            <th>Resource Link</th>
			            {tableComponent}
        			</table>
        		</GridCell>
      		</Grid>
	    )
	}
}
function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminMCListOfResourcesInt);


// WEBPACK FOOTER //
// ./src/views/admin/AdminMCListOfResourcesInt.jsx